import { createSelector } from 'reselect';
import { selectUser } from '../../../User/redux/selectors';

const selectIsPingerBot = createSelector(selectUser, (user = {}) => Boolean(user.pingerBot));

export default selectIsPingerBot;
